exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.entity-button{display:inline-block;padding:.75rem 2rem;outline:none;border:none;border-radius:3px;cursor:pointer;transition:box-shadow .2s cubic-bezier(0.4, 0, 1, 1),background-color .2s cubic-bezier(0.4, 0, 0.2, 1);box-shadow:0 2px 2px 0 rgba(153,153,153,.14),0 3px 1px -2px rgba(153,153,153,.2),0 1px 5px 0 rgba(153,153,153,.12)\n}\n.entity-button[disabled]{cursor:wait\n}\n.entity-button:not([disabled]):hover,.entity-button:not([disabled]):focus{box-shadow:0 14px 26px -12px rgba(153,153,153,.42),0 4px 23px 0px rgba(0,0,0,.12),0 8px 10px -5px rgba(153,153,153,.2)\n}", ""]);

// exports
